import { useEffect, useState } from "react";
import { useErrorBoundary } from "react-error-boundary";
import { axiosUnos } from "common/api/axios/unos_axios";

const UnosStart = () => {
  const { showBoundary } = useErrorBoundary();
  const [msgAuthRequiredUnos, setMsgAuthRequiredUnos] =
    useState<any>("unos not accessed");
  useEffect(() => {
    axiosUnos
      .get("auth/authrequired")
      .then((res) => {
        setMsgAuthRequiredUnos(res.statusText);
        setTimeout(() => {}, 2000);
      })
      .catch((err) => {
        console.log("unos res authrequired err", err.response.status);
      });
  }, []);

  return (
    <div>
      <div>START</div>
      <div>Unos: {msgAuthRequiredUnos}</div>
    </div>
  );
};

export default UnosStart;
